import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const getTotalNumAdults = (adults: string): number =>
  (adults || '').split(';').reduce((a, b) => a + parseInt(b, 10), 0);

export const getTotalNumChildren = (ages: string): number =>
  (ages || '').split(/[;,]/).filter((b) => b !== '' && b !== '0' && b !== '1').length;

export const getTotalNumInfants = (ages: string): number =>
  (ages || '').split(/[;,]/).filter((b) => b === '0' || b === '1').length;

export const getTotalNumChildrenInfants = (ages: string): number =>
  getTotalNumChildren(ages) + getTotalNumInfants(ages);

export const getAdultsChildrenCount = (searchParams: SearchParams): number =>
  getTotalNumAdults(searchParams[URLParameters.ADULTS]) + getTotalNumChildren(searchParams[URLParameters.AGES]);

export const getAdultsChildrenInfantsCount = (searchParams: SearchParams): number =>
  getTotalNumAdults(searchParams[URLParameters.ADULTS]) + getTotalNumChildrenInfants(searchParams[URLParameters.AGES]);

export const getTotalNumRooms = (adults: string): number => (adults || '').split(';').filter((a) => !!a).length;

export const hasChildren = (ages: string) => getTotalNumChildrenInfants(ages) > 0;
